import { z } from 'zod';

/**
 * UUID v7 (time-ordered) is the system's canonical ID format.
 * Accepts any UUID (v1–v8) for compatibility but our DB generates v7.
 */
export const UuidSchema = z.string().uuid().brand<'Uuid'>();
export type Uuid = z.infer<typeof UuidSchema>;

/**
 * Tenant identifier. Always a UUID in our system.
 * Branded separately from Uuid so TS catches "passed a user ID where a tenant ID was expected" bugs.
 */
export const TenantIdSchema = z.string().uuid().brand<'TenantId'>();
export type TenantId = z.infer<typeof TenantIdSchema>;

/**
 * User identifier.
 */
export const UserIdSchema = z.string().uuid().brand<'UserId'>();
export type UserId = z.infer<typeof UserIdSchema>;

/**
 * Tenant slug — URL-safe subdomain identifier.
 * Lowercase, alphanumeric + hyphens, 3–50 chars. Used in `<slug>.hrms.app` routing.
 */
export const TenantSlugSchema = z
  .string()
  .min(3)
  .max(50)
  .regex(/^[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/, 'Must be lowercase alphanumeric with hyphens')
  .brand<'TenantSlug'>();
export type TenantSlug = z.infer<typeof TenantSlugSchema>;
